// extracted by mini-css-extract-plugin
module.exports = {"title":"competencies-module--title--3R7gG","wrapper":"competencies-module--wrapper--3-6HS","item":"competencies-module--item--3Kfu1"};